import { render, staticRenderFns } from "./DescText.vue?vue&type=template&id=171eb052&"
import script from "./DescText.vue?vue&type=script&lang=js&"
export * from "./DescText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\ele-dynamic-form\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('171eb052')) {
      api.createRecord('171eb052', component.options)
    } else {
      api.reload('171eb052', component.options)
    }
    module.hot.accept("./DescText.vue?vue&type=template&id=171eb052&", function () {
      api.rerender('171eb052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/DescText.vue"
export default component.exports